import { getStore } from "@core/store";
export var Store = getStore();

//# sourceMappingURL=Store.js.map